import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppTheme } from '../models';
import { AuthService } from './auth.service';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private _theme$ = new BehaviorSubject<AppTheme>('brown');
  readonly theme$ = this._theme$.asObservable();

  get currentTheme(): AppTheme { return this._theme$.value; }

  constructor(private auth: AuthService, private api: ApiService) {}

  init(): void {
    const saved = this.auth.getStoredTheme();
    this.apply(saved);
  }

  setTheme(theme: AppTheme): void {
    this.apply(theme);
    this.auth.updateStoredTheme(theme);
    const user = this.auth.getCurrentUser();
    if (user?.userID) {
      this.api.saveUserTheme(user.userID, theme).subscribe({ error: () => {} });
    }
  }

  private apply(theme: AppTheme): void {
    document.documentElement.setAttribute('data-theme', theme);
    this._theme$.next(theme);
  }
}
